class FormulaChoice extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

    if (!this.tabs.length || !this.panels.length) return;

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.activate(tab, true));
      tab.addEventListener('keydown', (event) => this.handleKeydown(event));
    });

    const selectedTab = this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || this.tabs[0];
    this.activate(selectedTab, false);

    if (window.Shopify?.designMode) {
      this.handleBlockSelect = (event) => {
        const selectedBlock = this.tabs.find((tab) => tab.dataset.choiceBlock === event.detail.blockId);

        if (selectedBlock) this.activate(selectedBlock, false);
      };

      document.addEventListener('shopify:block:select', this.handleBlockSelect);
    }
  }

  disconnectedCallback() {
    if (this.handleBlockSelect) {
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
    }
  }

  activate(activeTab, moveFocus) {
    const controlledPanelId = activeTab.getAttribute('aria-controls');

    this.tabs.forEach((tab) => {
      const isActive = tab === activeTab;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', String(isActive));
      tab.tabIndex = isActive ? 0 : -1;
    });

    this.panels.forEach((panel) => {
      panel.hidden = panel.id !== controlledPanelId;
    });

    if (moveFocus) activeTab.focus();
  }

  handleKeydown(event) {
    const currentIndex = this.tabs.indexOf(event.currentTarget);
    let nextIndex;

    switch (event.key) {
      case 'ArrowDown':
      case 'ArrowRight':
        nextIndex = (currentIndex + 1) % this.tabs.length;
        break;
      case 'ArrowUp':
      case 'ArrowLeft':
        nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        break;
      case 'Home':
        nextIndex = 0;
        break;
      case 'End':
        nextIndex = this.tabs.length - 1;
        break;
      default:
        return;
    }

    event.preventDefault();
    this.activate(this.tabs[nextIndex], true);
  }
}

if (!customElements.get('formula-choice')) {
  customElements.define('formula-choice', FormulaChoice);
}
